var elem2 = document.querySelector('#shopify-section-product-story-sections .page-blocks');
var flkty2 = new Flickity( elem2, {
  // options
  cellAlign: 'left',
//   contain: true,
//   freeScroll: true,
  fullscreen: true,
  lazyLoad: 1,
  wrapAround: true,
  pageDots: false,
//   adaptiveHeight: true,
//   autoPlay: 5000,
  pauseAutoPlayOnHover: false
});



window.addEventListener('load', function() {
  console.log('B');
  
  setTimeout(function(){
    flkty2.resize();
  }, 1500);
  
})




$(document).ready(function() {


  var hash = window.location.hash.substr(1);

  if(window.location.pathname == '/products/product-1'){
    if(hash == 'care'){
      $('html, body').animate({
        scrollTop: $("#shopify-section-product-story-sections").offset().top - 100
      }, 1000);

    }
  }
  
  $('.site-footer .grid .grid__item:last-child ul.site-footer__linklist li:last-child a').click(function(){
    $('html, body').animate({
        scrollTop: $("#shopify-section-product-story-sections").offset().top - 100
      }, 1000);
  });
  
  
  $('body').on('click', '#create_customer .btn', function() {
    if ($('#terms').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions.");
      return false;
    }
  });
  
  $('body').on('click', '.contact-page .contact-form .btn', function() {
    if ($('#terms').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions.");
      return false;
    }
  });

});